/* eslint-disable no-script-url */
import React, { useEffect } from "react";
import Image from "../elements/Image";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { classNames } from "../../helpers/classNames";

const SwiperProduct = ({ data, fancybox, fancyboxAttribute, imageSize }) => {
  const fancyboxParameter = fancybox ? { "data-fancybox": fancyboxAttribute } : {};
  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']");
  }, []);
  return (
    <>
      {/* <div className="w-full overflow-hidden flex"> */}
      <a href={fancybox ? data?.imageUrl : "javascript:void(0)"} {...fancyboxParameter} className="flex w-full h-full">
        <Image
          src={data?.imageUrl}
          alt="testimonialimg"
          classes={classNames("w-full h-full !object-contain", imageSize)}
          effect="blur"
        />
      </a>
      {/* </div> */}
    </>
  );
};

export default SwiperProduct;
